/**
 * @description
 * @version
 * @author
 * @refer https://juejin.cn/post/7357609459345506330?earchId=20250730133928053080265BFB46DB6163
 */

// inject-click-handler.ts vite插件
import { parse } from 'vue/compiler-sfc';
import { Plugin } from 'vite';

interface Replacement {
  source: string;
  replaceSource: string;
}

export default (): Plugin => ({
  name: 'inject-click-handler',
  transform(code, id) {
    try {
      if (!/.vue$/.test(id)) return null;
      const parseCode = parse(code);
      if (!parseCode) return null;
      if (!parseCode.descriptor?.template?.content) return null;

      const { content } = parseCode.descriptor.template;

      let $code = content;
      const replacements: Replacement[] = [];

      // 递归遍历AST节点
      // 处理节点属性中的埋点逻辑
      const handleMdProp = (node: any, replacements: Replacement[]) => {
        const mdProp = node.props.find(
          (prop) =>
            (prop.type === 6 && prop.name === 'data-manual-track') ||
            (prop.type === 7 &&
              prop.name === 'bind' &&
              prop.arg?.content === 'data-manual-track'),
        );

        if (mdProp) {
          const tagName = node.tag;
          const mdContent =
            mdProp.type === 6
              ? `'${mdProp.value?.content || ''}'`
              : mdProp.exp?.content || '';

          const clickEvent = node.props.find(
            (prop) =>
              prop.type === 7 &&
              prop.name === 'on' &&
              prop.arg?.content === 'click',
          );

          const text =
            node.children.find((item) => item.type === 2)?.content ?? '';

          if (clickEvent) {
            const expContent = clickEvent.exp?.content || '';
            const isFunctionCall =
              /^\s*[a-zA-Z_$][\w$]*\s*\([^)]*\)\s*$|^\s*[a-zA-Z_$][\w$]*\s*$/.test(
                expContent,
              );
            const fixedExp = isFunctionCall
              ? /\([^)]*\)/.test(expContent)
                ? expContent
                : `${expContent}()`
              : /\s*[\w-]+\s*=\s*.*?\s*/.test(expContent)
                ? expContent
                : `${expContent}($event)`;

            const newEventString = `@click.stop="sendMd({
              content:${mdContent},
              tag:'${tagName}',
              text:'${text}'
            });${fixedExp}"`;

            const newNodeStr = node.loc.source
              .replace(clickEvent.loc.source, newEventString)
              .trim();

            replacements.push({
              source: node.loc.source,
              replaceSource: newNodeStr,
            });
          } else {
            const newEventString = `@click.stop="sendMd({
              content:${mdContent},
              tag:${tagName},
              text:'${text}'
            })"`;

            const closingBracketIndex = node.loc.source.lastIndexOf('>');
            const isSelfClosing =
              node.loc.source[closingBracketIndex - 1] === '/';

            const newNodeStr = isSelfClosing
              ? node.loc.source.slice(0, closingBracketIndex - 1).trim() +
              ` ${newEventString} />`
              : node.loc.source.slice(0, closingBracketIndex).trim() +
              ` ${newEventString}>`;

            replacements.push({
              source: node.loc.source,
              replaceSource: newNodeStr,
            });
          }
        } else if (node.tag === 'navigator' && node.type === 1) {
          const url =
            node.props.find((item) => item.name === 'url')?.value?.content ??
            node.props.find((item) => item.rawName === ':url')?.exp?.content;

          const newNodeStr = node.loc.source
            .replace(
              /<navigator([^>]*)>/,
              `<navigator$1 @click.stop="sendPageMd('${url}')">`,
            )
            .trim();

          replacements.push({
            source: node.loc.source,
            replaceSource: newNodeStr,
          });
        }
      };

      // 递归遍历AST节点
      const traverse = (node: any, replacements: Replacement[]) => {
        if (node?.props?.length) {
          handleMdProp(node, replacements);
        }

        if (node.children) {
          node.children.forEach((child: any) => traverse(child, replacements));
        }
      };

      // 开始遍历AST
      traverse(parseCode.descriptor.template.ast, replacements);

      // 按节点长度倒序替换（避免嵌套节点替换问题）
      replacements
        .sort((a, b) => b.source.length - a.source.length)
        .forEach(({ source, replaceSource }) => {
          $code = $code.replace(source, replaceSource);
        });

      // 返回修改后的代码
      return {
        code: code.replace(content, $code),
        map: null,
      };
    } catch (e) {
      console.error(`埋点注入失败: ${e}`);
      return null;
    }
  },
});
